/**
 * Module summary:
 * This page presents the company's mission, vision, background, and leadership
 * team. It is mostly static content, with a small data array used to render
 * the executive cards consistently.
 */

import React from 'react';
import AppShell from '../layout/AppShell';
import './pages.css';

const leaders = [
  // Keep leadership metadata in one array so the card layout stays easy to update.
  {
    name: 'Travis Valley',
    title: 'Chief Executive Officer',
    image: '/images/Travis-Valley.png',
  },
  {
    name: 'Dr. Bobby Lambert',
    title: 'Chief Operating Officer',
    image: '/images/bobby-lambert.png',
  },
  {
    name: 'Schuyler Moran',
    title: 'Chief Technology Officer',
    image: '/images/schuyler-moran.png',
  },
];

export const AboutUs: React.FC = () => (
  <AppShell title="About Us" isDashboard>
    <div className="content-page">
      <section className="content-page__hero content-page__hero--dark about-hero">
        <div className="content-page__hero-copy">
          <div className="about-hero__badge" aria-hidden>
            <img src="/Transparent-Logo.png" alt="" />
            <span>ABOUT THE MACHA GROUP</span>
          </div>
          <p className="content-page__eyebrow">About The Macha Group</p>
          <h1 className="content-page__title">Practical security leadership for real-world environments.</h1>
          <p className="content-page__subtitle">
            We help organizations identify vulnerabilities, reduce exposure, and build stronger operational resilience
            across physical and digital environments.
          </p>
        </div>
        <div className="about-hero__logo-wrap" aria-hidden>
          <img src="/Transparent-Logo.png" alt="" className="about-hero__logo" />
        </div>
      </section>

      <section className="content-grid content-grid--two">
        <article className="content-card">
          <p className="content-card__eyebrow">Our Mission</p>
          <h2 className="content-card__title">Proactive protection, not reactive cleanup.</h2>
          <p className="content-card__copy">
            We safeguard organizations by proactively identifying and addressing vulnerabilities before they become
            operational threats. Our work is built around clarity, readiness, and practical mitigation.
          </p>
        </article>

        <article className="content-card">
          <p className="content-card__eyebrow">Our Vision</p>
          <h2 className="content-card__title">Set the standard for modern security assessments.</h2>
          <p className="content-card__copy">
            Our goal is to be the leading authority in vulnerability assessment and threat mitigation by combining field
            discipline, strategic advisory work, and usable technology.
          </p>
        </article>
      </section>

      <section className="content-card content-card--split about-story">
        <div className="content-card__copy-block">
          <p className="content-card__eyebrow">Who We Are</p>
          <h2 className="content-card__title">Built for environments where failure is expensive.</h2>
          <p className="content-card__copy">
            In a world where security threats keep evolving, proactive defense is no longer optional. Schools, public
            facilities, and private organizations need clearer visibility into what is exposed, what is working, and what
            needs immediate attention.
          </p>
          <p className="content-card__copy">
            The Macha Group was founded in 2023 by a team built on discipline, integrity, and a working understanding of
            real threat environments. We focus on actionable assessment, not inflated reporting.
          </p>
        </div>
        <div className="content-card__media">
          <img
            src="/images/field-assessment.png?v=2"
            alt="Security professional conducting a facility assessment"
            className="content-card__image"
          />
        </div>
      </section>

      <section className="content-card">
        <div className="content-card__header">
          <div>
            <p className="content-card__eyebrow">Leadership</p>
            <h2 className="content-card__title">Executive Team</h2>
          </div>
        </div>

        <div className="leaders-grid-v2">
          {leaders.map((leader) => (
            <article key={leader.name} className="leader-card-v2">
              <div className="leader-card-v2__media">
                <img src={leader.image} alt={leader.name} className="leader-card-v2__image" />
              </div>
              <h3 className="leader-card-v2__name">{leader.name}</h3>
              <p className="leader-card-v2__title">{leader.title}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  </AppShell>
);

export default AboutUs;
